import api from "./api";

// Service pour les importations
const importService = {
  // Importer un fichier Excel
  uploadFile: async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await api.post("/imports/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  },

  // Obtenir les détails d'une importation
  getImportDetails: async (id) => {
    const response = await api.get(`/imports/${id}`);
    return response.data;
  },

  // Obtenir l'historique des importations
  getImports: async (params) => {
    const response = await api.get("/imports", { params });
    return response.data;
  },

  // Méthode pour obtenir le statut d'une importation
  getImportStatus: async (importId) => {
    try {
      const response = await api.get(`/imports/status/${importId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Erreur lors de la vérification du statut');
    }
  },

  // 🆕 NOUVEAU: Obtenir les informations sur la queue d'importations
  getQueueInfo: async () => {
    try {
      const response = await api.get('/imports/queue-info');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Erreur lors de la récupération des informations de queue');
    }
  }
};

export default importService;